import moment from "moment";
import { cloneDeep } from "lodash";
import Select from "react-select";
import Cards from "react-credit-cards";
import React, { Component } from "react";
import {
  Card,
  CardBody,
  Label,
  Input,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
  UncontrolledCollapse,
  Tooltip,
} from "reactstrap";
import { BsPlusCircle } from "react-icons/bs";
import { IoMdEye } from "react-icons/io";
import { MdDeleteForever, MdEdit, MdPayment } from "react-icons/md";

import * as Server from "../../Server";
import Page from "../../components/Page";
import PageSpinner from "../../components/PageSpinner";
import * as GeneralFunctions from "../../GeneralFunctions";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";
import { GlobalContext } from "../../components/Layout/MainLayout";

let user = {};

class ParentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // page: 1,
      // pages: 0,
      // limit: 10,
      globalSearchData: "",
      rushUsers: [],
      rushUser: {},
      totalUsers: 0,
      // pageNumbers: [],
      playerViewModal: false,
      registerPlayerModal: false,
      registerFormFieldsPlayers: [],
      wavierFormFieldsPlayers: [],
      player: {},
      clubId: "",
      registerParentModal: false,
      registerFormFieldsAdult: [],
      wavierFormFieldsAdult: [],
      adult: {},
      adultDeleteConfirmationModal: false,
      adultDeleteId: "",
      adultEditModal: false,
      adultViewModal: false,
      cardViewModal: false,
      // type: "",
      addCardCollapse: false,
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      adultViewDetailsToolTip: false,
      adultEditToolTip: false,
      adultViewCreditCardToolTip: false,
      adultDeleteToolTip: false,
      adultViewDetailsSelectedIndex: null,
      adultEditSelectedIndex: null,
      adultViewCreditCardSelectedIndex: null,
      adultDeleteSelectedIndex: null,
      SPIRegistered: false,
      SPIParentCamps: [],
      SPIParentCampOptions: [],
      selectedSPIParentCamp: {},
      SPICamps: [],
      SPICampOptions: [],
      selectedSPICamp: {},
    };
  }

  componentDidMount() {
    user = GeneralFunctions.getAuthUser();
    let SPIRegistered = user.scoccerClub === "SPI Rush";
    this.setState({ limit: this.context.limit, SPIRegistered }, () =>
      this.getParents()
    );
  }

  getParents = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: `social/register/user?SPIEvent=${this.state.SPIRegistered}`,
        method: "GET",
      });
      if (response) {
        if (!response.users.length) {
          this.props.history.push({
            pathname: "/webapp/register",
            state: { users: true },
          });
        }
        if (this.state.SPIRegistered) {
          await this.getRushNationalCamps();
        } else if (response.users.length) {
          await this.getRegistrationForm(response.users[0].clubId);
        }
        this.setState({
          showLoader: false,
          rushUsers: response.users,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRushNationalCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccerapp/rushNational/camps",
        method: "GET",
        token: "marketplaceAccessToken",
      });
      if (response) {
        let SPIParentCampOptions = response.camps.map((camp) => ({
          label: camp.name,
          value: camp._id,
        }));
        let selectedSPIParentCamp = SPIParentCampOptions.length
          ? SPIParentCampOptions[0]
          : {};
        let SPICamps = response.camps.length ? response.camps[0].camps : [];
        let SPICampOptions = SPICamps.map((camp) => ({
          label: camp.name,
          value: camp._id,
        }));
        let selectedSPICamp = SPICampOptions.length ? SPICampOptions[0] : {};
        this.setState(
          {
            showLoader: false,
            SPIParentCamps: response.camps,
            SPIParentCampOptions,
            SPICamps,
            SPICampOptions,
            selectedSPIParentCamp,
            selectedSPICamp,
          },
          () => this.getRegistrationFormForRushNationals()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRegistrationForm = async (clubId) => {
    try {
      this.setState({ showLoader: true });
      if (!clubId) {
        this.setState({
          registerFormFieldsAdult: [],
          registerFormFieldsPlayers: [],
        });
        return;
      }
      let response = await Server.request({
        url: `rushsoccer/registration/form?clubId=${clubId}`,
        method: "GET",
      });
      if (
        response.registrationFormDetails &&
        response.registrationFormDetails.registerForm
      ) {
        let allFields = response.registrationFormDetails.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        let playerFields = allFields.filter(
          (form) =>
            form.for.value === "player" &&
            // form.inputType !== "fileupload" && //remove fileuploads
            form._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14"
        );
        let wavierFormFieldsPlayers = allFields.filter(
          (form) => form.for.value === "player" && form.inputType === "waviers"
        );
        let adultFields = allFields
          .filter(
            (form) => form.for.value === "adult"
            // && form.inputType !== "fileupload" //remove fileuploads
          )
          .map((field) =>
            field.keyName === "photo"
              ? Object.assign(field, { keyName: "photo1" })
              : field
          );
        let wavierFormFieldsAdult = allFields.filter(
          (form) => form.for.value === "adult" && form.inputType === "waviers"
        );
        this.setState({
          showLoader: false,
          clubId: response.registrationFormDetails._id,
          registerFormFieldsPlayers: playerFields,
          wavierFormFieldsPlayers,
          registerFormFieldsAdult: adultFields,
          wavierFormFieldsAdult,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRegistrationFormForRushNationals = async () => {
    try {
      this.setState({ showLoader: true });
      let SPICamp = this.state.SPICamps.find(
        (SPICamp) => SPICamp._id === this.state.selectedSPICamp.value
      );
      if (!SPICamp || !SPICamp.registerForm) {
        this.setState({
          showLoader: false,
          registerFormFieldsPlayers: [],
          wavierFormFieldsPlayers: [],
          registerFormFieldsAdult: [],
          wavierFormFieldsAdult: [],
        });
        return;
      }
      let registerForm = SPICamp.registerForm;
      let allFields = registerForm.reduce((previousValue, currentValue) => {
        previousValue.push(...currentValue.fields);
        return previousValue;
      }, []);
      let playerFields = allFields.filter(
        (form) =>
          form.for.value === "player" &&
          // form.inputType !== "fileupload" && //remove fileuploads
          form._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14" &&
          form._id !== "584f8f03-d257-4cf7-b440-9a2a7d730ea3"
      );
      let wavierFormFieldsPlayers = allFields.filter(
        (form) => form.for.value === "player" && form.inputType === "waviers"
      );
      let adultFields = allFields
        .filter(
          (form) => form.for.value === "adult"
          // && form.inputType !== "fileupload" //remove fileuploads
        )
        .map((field) =>
          field.keyName === "photo"
            ? Object.assign(field, { keyName: "photo1" })
            : field
        );
      let wavierFormFieldsAdult = allFields.filter(
        (form) => form.for.value === "adult" && form.inputType === "waviers"
      );
      this.setState({
        showLoader: false,
        clubId: SPICamp.clubId,
        registerFormFieldsPlayers: playerFields,
        wavierFormFieldsPlayers,
        registerFormFieldsAdult: adultFields,
        wavierFormFieldsAdult,
      });
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };
  updateState = async (type, key, value) => {
    if (value === "on") {
      switch (type) {
        case "adult":
          value = !this.state.adult[key];
          break;
        case "player":
          value = !this.state.player[key];
          break;
        default:
          break;
      }
    }
    if (key === "phone" || key === "playerPhone") {
      if (value.length > 10) {
        return true;
      }
    }
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: value,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: value,
          },
        }));
        break;
      default:
        break;
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      if (this.state.SPIRegistered) {
        if (
          !this.state.selectedSPICamp.value ||
          !this.state.selectedSPIParentCamp.value
        ) {
          throw Error("Select the rush national program");
        }
      }
      let formData = new FormData();
      this.setState({ showLoader: true });
      let playerFileFields = this.state.registerFormFieldsPlayers.filter(
        (field) => field.inputType === "dropdown"
      );
      for (let index = 0; index < playerFileFields.length; index++) {
        const playerFileField = playerFileFields[index];
        if (playerFileField.required) {
          if (!this.state.player[playerFileField.keyName]) {
            throw Error(`Select the ${playerFileField.placeholder}`);
          }
        }
      }
      let playerFileUploadFields = this.state.registerFormFieldsPlayers
        .filter((field) => field.inputType === "fileupload")
        .map((field) => Object.assign(field, { for: "player" }));
      for (let index = 0; index < playerFileUploadFields.length; index++) {
        const playerFileUploadField = playerFileUploadFields[index];
        if (playerFileUploadField.required) {
          if (this.state.player[playerFileUploadField.keyName]) {
            formData.append(
              [playerFileUploadField.keyName],
              this.state.player[playerFileUploadField.keyName]
            );
          } else {
            throw Error(`Select the ${playerFileUploadField.placeholder}`);
            // let blob = this.dataURItoBlob(DefaultImage);
            // formData.append(
            //   [playerFileUploadField.keyName],
            //   blob,
            //   "defaultUser.png"
            // );
          }
        } else {
          if (this.state.player[playerFileUploadField.keyName])
            formData.append(
              [playerFileUploadField.keyName],
              this.state.player[playerFileUploadField.keyName]
            );
        }
      }
      if (this.state.SPIRegistered) {
        Object.assign(this.state.player, {
          parentEventId: this.state.selectedSPIParentCamp.value,
        });
        Object.assign(this.state.player, {
          parentEventName: this.state.selectedSPIParentCamp.label,
        });
        Object.assign(this.state.player, {
          SPIEventId: this.state.selectedSPICamp.value,
        });
        Object.assign(this.state.player, {
          SPIEventName: this.state.selectedSPICamp.label,
        });
      }
      formData.append("clubId", this.state.clubId);
      formData.append("SPIRegistered", this.state.SPIRegistered);
      formData.append("parentId", this.state.rushUser._id);
      formData.append("player", JSON.stringify(this.state.player));
      let deleteKeys = playerFileUploadFields.map((fields) => ({
        keyName: fields.keyName,
        for: fields.for,
      }));
      if (deleteKeys && deleteKeys.length)
        formData.append("deleteKeys", JSON.stringify(deleteKeys));
      let response = await Server.serverRequest(
        {
          url: "rushUser/webapp/registerPlayer",
          method: "POST",
          data: formData,
        },
        false
      );
      if (response) {
        if (response.success) {
          if (response.user.child.length) {
            response.user.child = response.user.child.filter(
              (kid) => !kid.systemGenerated
            );
          }
          this.setState(
            {
              showLoader: false,
              player: {},
              rushUser: {},
            },
            () => this.getParents()
          );
          this.toggleRegisterPlayerModal();
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  registerAdult = async (event) => {
    event.preventDefault();
    try {
      if (this.state.SPIRegistered) {
        if (
          !this.state.selectedSPICamp.value ||
          !this.state.selectedSPIParentCamp.value
        ) {
          throw Error("Select the rush national program");
        }
      }
      let formData = new FormData();
      this.setState({ showLoader: true });
      let adultFileFields = this.state.registerFormFieldsAdult.filter(
        (field) => field.inputType === "dropdown"
      );
      for (let index = 0; index < adultFileFields.length; index++) {
        const adultFileField = adultFileFields[index];
        if (adultFileField.required) {
          if (!this.state.adult[adultFileField.keyName]) {
            throw Error(`Select the ${adultFileField.placeholder}`);
          }
        }
      }
      let adultFileUploadFields = this.state.registerFormFieldsAdult
        .filter((field) => field.inputType === "fileupload")
        .map((field) => Object.assign(field, { for: "adult" }));
      for (let index = 0; index < adultFileUploadFields.length; index++) {
        const adultFileUploadField = adultFileUploadFields[index];
        if (adultFileUploadField.required) {
          if (this.state.adult[adultFileUploadField.keyName]) {
            formData.append(
              [adultFileUploadField.keyName],
              this.state.adult[adultFileUploadField.keyName]
            );
          } else {
            throw Error(`Select the ${adultFileUploadField.placeholder}`);
            // let blob = this.dataURItoBlob(DefaultImage);
            // formData.append(
            //   [adultFileUploadField.keyName],
            //   blob,
            //   "defaultUser.png"
            // );
          }
        } else {
          if (this.state.adult[adultFileUploadField.keyName])
            formData.append(
              [adultFileUploadField.keyName],
              this.state.adult[adultFileUploadField.keyName]
            );
        }
      }
      if (this.state.SPIRegistered) {
        Object.assign(this.state.adult, {
          parentEventId: this.state.selectedSPIParentCamp.value,
        });
        Object.assign(this.state.adult, {
          parentEventName: this.state.selectedSPIParentCamp.label,
        });
        Object.assign(this.state.adult, {
          SPIEventId: this.state.selectedSPICamp.value,
        });
        Object.assign(this.state.adult, {
          SPIEventName: this.state.selectedSPICamp.label,
        });
      }
      formData.append("clubId", this.state.rushUsers[0].clubId);
      formData.append("adult", JSON.stringify(this.state.adult));
      formData.append("SPIRegistered", this.state.SPIRegistered);
      formData.append("parentId", this.state.rushUsers[0]._id);
      let deleteKeys = adultFileUploadFields.map((fields) => ({
        keyName: fields.keyName,
        for: fields.for,
      }));
      if (deleteKeys && deleteKeys.length)
        formData.append("deleteKeys", JSON.stringify(deleteKeys));
      let response = await Server.serverRequest(
        {
          url: "rushUser/webapp/registerAdult",
          method: "POST",
          data: formData,
        },
        false
      );
      if (response) {
        if (response.success) {
          this.setState({
            showLoader: false,
            adult: [],
          });
          this.toggleRegisterParentModal();
          this.getParents();
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      }
      window.scrollTo(0, 0);
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  updateAdult = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let formData = new FormData();
      formData.append("registerFor", "parent");
      formData.append("parentId", this.state.rushUser._id);
      let adultFields = cloneDeep(this.state.registerFormFieldsAdult).filter(
        (form) => form.for.value === "adult" && form.inputType !== "fileupload" //remove fileuploads
      );
      for (let index = 0; index < adultFields.length; index++) {
        const field = adultFields[index];
        formData.append([field.keyName], this.state.adult[field.keyName]);
      }
      let adultFileUploadFields = cloneDeep(this.state.registerFormFieldsAdult)
        .filter((field) => field.inputType === "fileupload")
        .map((field) => Object.assign(field, { for: "adult" }));
      for (let index = 0; index < adultFileUploadFields.length; index++) {
        const adultFileUploadField = adultFileUploadFields[index];
        if (
          adultFileUploadField.keyName === "photo1" &&
          this.state.adult[adultFileUploadField.keyName]
        ) {
          formData.append(
            "photo",
            this.state.adult[adultFileUploadField.keyName]
          );
        }
        if (this.state.adult[adultFileUploadField.keyName])
          formData.append(
            [adultFileUploadField.keyName],
            this.state.adult[adultFileUploadField.keyName]
          );
      }
      let response = await Server.serverRequest({
        url: "social/user/update",
        method: "POST",
        data: formData,
      });
      if (response) {
        if (response.success) {
          this.setState({
            showLoader: false,
            adult: [],
          });
          this.toggleAdultEditModal();
          this.getParents();
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      }
      window.scrollTo(0, 0);
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  removeAdult = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "social/user/delete",
        method: "POST",
        data: {
          delete: "parent",
          deleteType: "delete",
          parentId: this.state.rushUser._id,
          SPIEvent: this.state.rushUser.SPIRegistered,
        },
      });
      if (response) {
        if (response.success) {
          this.setState({
            showLoader: false,
            adult: [],
          });
          this.toggleAdultDeleteConfirmationModal();
          this.getParents();
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      }
      window.scrollTo(0, 0);
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  handleChange = async (type, key, event) => {
    const fileUploaded = event.target.files[0];
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      default:
        break;
    }
    event.target.value = null;
  };

  addCreditCard = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "card",
          APIVersion: "v2",
          parentId: this.state.rushUser._id,
          cvc: this.state.cvc,
          number: this.state.number,
          exp_year: this.state.expiry.length
            ? this.state.expiry.substring(2, 4)
            : "",
          exp_month: this.state.expiry.length
            ? this.state.expiry.substring(0, 2)
            : "",
          cardType: this.state.cardType,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
          addCardCollapse: false,
        });
        this.toggleCardViewModal();
        this.getParents();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };
  // refreshPagination = (page, limit) => {
  //   this.setState({ page: parseInt(page, 10), limit: limit }, () => {
  //     this.getParents();
  //   });
  // };

  togglePlayerViewModal = (rushUser) => {
    this.setState({
      rushUser: rushUser ? rushUser : {},
      playerViewModal: !this.state.playerViewModal,
    });
  };

  toggleRegisterPlayerModal = (rushUser) => {
    this.setState({
      rushUser: rushUser ? rushUser : {},
      registerPlayerModal: !this.state.registerPlayerModal,
    });
  };

  toggleRegisterParentModal = () => {
    this.setState({ registerParentModal: !this.state.registerParentModal });
  };

  toggleAdultDeleteConfirmationModal = (rushUser) => {
    this.setState({
      rushUser: rushUser ? rushUser : {},
      adultDeleteConfirmationModal: !this.state.adultDeleteConfirmationModal,
    });
  };

  toggleAdultEditModal = (adult, rushUser) => {
    this.setState({
      rushUser: rushUser ? rushUser : {},
      adult: adult ? adult : {},
      adultEditModal: !this.state.adultEditModal,
    });
  };

  toggleAdultViewModal = (adult, rushUser) => {
    if (this.state.SPIRegistered) {
      if (adult) {
        let selectedSPIParentCamp = {
          label: adult.parentEventName,
          value: adult.parentEventId,
        };
        let selectedSPICamp = {
          label: adult.SPIEventName,
          value: adult.SPIEventId,
        };
        let camp = this.state.SPIParentCamps.find(
          (SPIParentCamp) => SPIParentCamp._id === selectedSPIParentCamp.value
        );
        let SPICamps = camp ? camp.camps : [];
        let SPICampOptions = SPICamps.map((camp) => ({
          label: camp.name,
          value: camp._id,
        }));
        this.setState(
          {
            SPICamps,
            SPICampOptions,
            selectedSPIParentCamp,
            selectedSPICamp,
            rushUser: rushUser ? rushUser : {},
            adult: adult ? adult : {},
            adultViewModal: !this.state.adultViewModal,
          },
          () => this.getRegistrationFormForRushNationals()
        );
      } else {
        this.setState({
          rushUser: rushUser ? rushUser : {},
          adult: adult ? adult : {},
          adultViewModal: !this.state.adultViewModal,
        });
      }
    } else {
      this.setState({
        rushUser: rushUser ? rushUser : {},
        adult: adult ? adult : {},
        adultViewModal: !this.state.adultViewModal,
      });
    }
  };

  toggleCardViewModal = (rushUser) => {
    this.setState({
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      addCardCollapse: false,
      rushUser: rushUser ? rushUser : {},
      cardViewModal: !this.state.cardViewModal,
    });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page title="Parents" breadcrumbs={[{ name: "Parents", active: true }]}>
          <Card>
            {/* <CardHeader>
              <Row>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex">
                    <div sm={4} className="mt-2 pr-2">
                      <Label>Shown</Label>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        name="pageLimit"
                        value={this.state.limit}
                        onChange={(event) => {
                          this.refreshPagination(1, event.target.value);
                          this.context.updateState({
                            limit: event.target.value,
                          });
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Input>
                    </div>
                    <div sm={4} className="mt-2 pl-2">
                      <Label>entries</Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-center">
                    <div className="mt-2 pr-2">
                      <Label>
                        Showing{" "}
                        {!this.state.totalUsers
                          ? 0
                          : this.state.page * this.state.limit -
                          (this.state.limit - 1) +
                          " "}{" "}
                        to{" "}
                        {this.state.page * this.state.limit >
                          this.state.totalUsers
                          ? this.state.totalUsers
                          : this.state.page * this.state.limit}{" "}
                        of {this.state.totalUsers}
                      </Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-end">
                    <div sm={4} className="pr-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page <= 1}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page - 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                      </Button>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        value={this.state.page}
                        name="filter"
                        onChange={(event) => {
                          this.refreshPagination(
                            event.target.value,
                            this.state.limit
                          );
                        }}
                      >
                        {this.state.pageNumbers.length !== 0 ? (
                          this.state.pageNumbers.map((pageNumber, index) => (
                            <option value={pageNumber} key={index}>
                              {pageNumber}
                            </option>
                          ))
                        ) : (
                          <option value={0}>0</option>
                        )}
                      </Input>
                    </div>
                    <div sm={4} className="pl-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page >= this.state.pages}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page + 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardHeader> */}
            <CardBody>
              <Row>
                <Col xl={12} lg={12} md={12}>
                  <div className="d-flex justify-content-end">
                    <Button
                      color="primary"
                      style={{
                        float: "right",
                        marginBottom: "10px",
                      }}
                      onClick={() => this.toggleRegisterParentModal()}
                    >
                      Add Adult
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Players</th>
                        <th>Add Player</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rushUsers.length > 0 ? (
                        this.state.rushUsers.map((user, index) => (
                          <tr key={index}>
                            <td>{user.data.firstName}</td>
                            <td>{user.data.lastName}</td>
                            <td>{user.data.email}</td>
                            <td>{user.data.phone}</td>
                            <td>
                              <div
                                style={{ color: "#17517b", cursor: "pointer" }}
                                onClick={() => this.togglePlayerViewModal(user)}
                              >
                                View
                              </div>
                            </td>
                            <td>
                              <BsPlusCircle
                                size="25px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.toggleRegisterPlayerModal(user)
                                }
                              />
                            </td>
                            <td>
                              <IoMdEye
                                className="mr-1"
                                size="25px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.toggleAdultViewModal(user.data, user)
                                }
                                onMouseOver={() =>
                                  this.setState({
                                    adultViewDetailsSelectedIndex: index,
                                    adultViewDetailsToolTip: true,
                                  })
                                }
                                onMouseOut={() =>
                                  this.setState({
                                    adultViewDetailsSelectedIndex: null,
                                    adultViewDetailsToolTip: false,
                                  })
                                }
                                id={`adultViewDetailsToolTip${index}`}
                              />
                              <Tooltip
                                placement="bottom"
                                isOpen={
                                  this.state.adultViewDetailsToolTip &&
                                  this.state.adultViewDetailsSelectedIndex ===
                                    index
                                }
                                target={`adultViewDetailsToolTip${index}`}
                                toggle={() => {}}
                              >
                                View adult details
                              </Tooltip>
                              <MdEdit
                                className="mr-1"
                                size="25px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.toggleAdultEditModal(user.data, user)
                                }
                                onMouseOver={() =>
                                  this.setState({
                                    adultEditSelectedIndex: index,
                                    adultEditToolTip: true,
                                  })
                                }
                                onMouseOut={() =>
                                  this.setState({
                                    adultEditSelectedIndex: null,
                                    adultEditToolTip: false,
                                  })
                                }
                                id={`adultEditToolTip${index}`}
                              />
                              <Tooltip
                                placement="bottom"
                                isOpen={
                                  this.state.adultEditToolTip &&
                                  this.state.adultEditSelectedIndex === index
                                }
                                target={`adultEditToolTip${index}`}
                                toggle={() => {}}
                              >
                                Edit adult
                              </Tooltip>
                              <MdPayment
                                size="25px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                }}
                                onClick={() => this.toggleCardViewModal(user)}
                                onMouseOver={() =>
                                  this.setState({
                                    adultViewCreditCardSelectedIndex: index,
                                    adultViewCreditCardToolTip: true,
                                  })
                                }
                                onMouseOut={() =>
                                  this.setState({
                                    adultViewCreditCardSelectedIndex: null,
                                    adultViewCreditCardToolTip: false,
                                  })
                                }
                                id={`adultViewCreditCardToolTip${index}`}
                              />
                              <Tooltip
                                placement="bottom"
                                isOpen={
                                  this.state.adultViewCreditCardToolTip &&
                                  this.state
                                    .adultViewCreditCardSelectedIndex === index
                                }
                                target={`adultViewCreditCardToolTip${index}`}
                                toggle={() => {}}
                              >
                                View credit cards
                              </Tooltip>
                              <MdDeleteForever
                                size="25px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.toggleAdultDeleteConfirmationModal(user)
                                }
                                onMouseOver={() =>
                                  this.setState({
                                    adultDeleteSelectedIndex: index,
                                    adultDeleteToolTip: true,
                                  })
                                }
                                onMouseOut={() =>
                                  this.setState({
                                    adultDeleteSelectedIndex: null,
                                    adultDeleteToolTip: false,
                                  })
                                }
                                id={`adultDeleteToolTip${index}`}
                              />
                              <Tooltip
                                placement="bottom"
                                isOpen={
                                  this.state.adultDeleteToolTip &&
                                  this.state.adultDeleteSelectedIndex === index
                                }
                                target={`adultDeleteToolTip${index}`}
                                toggle={() => {}}
                              >
                                Delete adult
                              </Tooltip>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No parents found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {this.state.playerViewModal ? (
            <Modal
              isOpen={this.state.playerViewModal}
              toggle={(event) => this.togglePlayerViewModal()}
              className="modal-md"
            >
              <ModalHeader toggle={(event) => this.togglePlayerViewModal()}>
                Players
              </ModalHeader>
              <ModalBody>
                <Table responsive style={{ marginBottom: "0px" }}>
                  <thead>
                    <tr>
                      <th>Player Name</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.rushUser.child &&
                    this.state.rushUser.child.length ? (
                      this.state.rushUser.child.map((value, index) => (
                        <tr key={index}>
                          <td>{`${value.data.firstName} ${value.data.lastName}`}</td>
                          <td>
                            <div
                              style={{ color: "#17517b", cursor: "pointer" }}
                              onClick={() =>
                                this.props.history.push({
                                  pathname: "/rushUserPlayerDetail",
                                  state: { childId: value._id },
                                })
                              }
                            >
                              View
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center"
                          style={{ background: "#dee2e6" }}
                        >
                          Players not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </Modal>
          ) : null}
          {this.state.registerPlayerModal ? (
            <Modal
              isOpen={this.state.registerPlayerModal}
              toggle={(event) => this.toggleRegisterPlayerModal()}
              className="modal-md"
            >
              <ModalHeader toggle={() => this.toggleRegisterPlayerModal()}>
                Register Player :
              </ModalHeader>
              <ModalBody>
                <Form className="form" onSubmit={this.onSubmit}>
                  {this.state.SPIRegistered ? (
                    <>
                      <Col>
                        <FormGroup>
                          <Label>
                            Select Rush National Program
                            <span
                              style={{
                                color: "red",
                                marginLeft: "5px",
                              }}
                            >
                              *
                            </span>
                          </Label>
                          <Select
                            placeholder="Select the program"
                            value={this.state.selectedSPIParentCamp}
                            options={this.state.SPIParentCampOptions}
                            onChange={(result) => {
                              let SPIParentCampId = result.value;
                              let camp = this.state.SPIParentCamps.find(
                                (SPIParentCamp) =>
                                  SPIParentCamp._id === SPIParentCampId
                              );
                              let SPICamps = camp ? camp.camps : [];
                              let SPICampOptions = SPICamps.map((camp) => ({
                                label: camp.name,
                                value: camp._id,
                              }));
                              let selectedSPICamp = SPICampOptions.length
                                ? SPICampOptions[0]
                                : {};
                              this.setState(
                                {
                                  selectedSPIParentCamp: result,
                                  SPICamps,
                                  SPICampOptions,
                                  selectedSPICamp,
                                },
                                () => this.getRegistrationFormForRushNationals()
                              );
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>
                            Select Rush National Program
                            <span
                              style={{
                                color: "red",
                                marginLeft: "5px",
                              }}
                            >
                              *
                            </span>
                          </Label>
                          <Select
                            placeholder="Select the program"
                            value={this.state.selectedSPICamp}
                            options={this.state.SPICampOptions}
                            onChange={(result) => {
                              this.setState(
                                {
                                  selectedSPICamp: result,
                                },
                                () => this.getRegistrationFormForRushNationals()
                              );
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </>
                  ) : null}
                  {this.state.registerFormFieldsPlayers.map(
                    (registerFormField, index) => (
                      <Col key={index}>
                        <FormGroup>
                          {registerFormField.inputType === "text" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                id={index}
                                name={registerFormField.name}
                                type="text"
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || ""
                                }
                                onChange={(event) =>
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "number" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                id={index}
                                name={registerFormField.name}
                                type="number"
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || ""
                                }
                                onChange={(event) =>
                                  event.target.value > -1 &&
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "datepicker" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                id={index}
                                name={registerFormField.name}
                                type="date"
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || ""
                                }
                                onChange={(event) =>
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "dropdown" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                disabled={this.state.playerDisabledFields}
                                type="select"
                                name={registerFormField.name}
                                value={
                                  this.state.player[
                                    registerFormField.keyName
                                  ] || "default"
                                }
                                required={registerFormField.required}
                                onChange={(event) =>
                                  this.updateState(
                                    "player",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                              >
                                <option value="default" disabled>
                                  Select the value
                                </option>
                                {registerFormField.values.map(
                                  (value, index) => (
                                    <option key={index} value={value}>
                                      {value}
                                    </option>
                                  )
                                )}
                              </Input>
                            </>
                          )}
                          {registerFormField.inputType === "fileupload" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <div>
                                <Label htmlFor={registerFormField._id}>
                                  <span className="btn btn-secondary">
                                    Select File
                                  </span>
                                  <span style={{ marginLeft: "5px" }}>
                                    {
                                      this.state.player[
                                        `${registerFormField.keyName}FileName`
                                      ]
                                    }
                                  </span>
                                </Label>
                                <input
                                  style={{ display: "none" }}
                                  id={registerFormField._id}
                                  type="file"
                                  onChange={(event) =>
                                    this.handleChange(
                                      "player",
                                      registerFormField.keyName,
                                      event
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                        </FormGroup>
                      </Col>
                    )
                  )}
                  {this.state.wavierFormFieldsPlayers.length ? (
                    <>
                      <Col
                        style={{
                          textAlign: "center",
                          padding: "10px 0px",
                          borderTop: "3px solid #e4e5e6",
                        }}
                      >
                        <h3>Waviers For Players</h3>
                      </Col>
                      {this.state.wavierFormFieldsPlayers.map(
                        (wavierFormField, index) => (
                          <Col key={index}>
                            <FormGroup>
                              {wavierFormField.inputType === "waviers" && (
                                <>
                                  <div className="d-flex">
                                    <CustomInput
                                      type="checkbox"
                                      id={wavierFormField._id}
                                      label={wavierFormField.placeholder}
                                      required={wavierFormField.required}
                                      checked={
                                        this.state.player[
                                          wavierFormField.keyName
                                        ] || false
                                      }
                                      onChange={(event) =>
                                        this.updateState(
                                          "player",
                                          wavierFormField.keyName,
                                          event.target.value
                                        )
                                      }
                                    />
                                    {wavierFormField.required && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        *
                                      </span>
                                    )}
                                  </div>
                                  <Input
                                    id={index}
                                    type="textarea"
                                    disabled
                                    style={{ height: "160px" }}
                                    value={wavierFormField.value}
                                  />
                                </>
                              )}
                            </FormGroup>
                          </Col>
                        )
                      )}
                    </>
                  ) : null}
                  <Col
                    style={{
                      textAlign: "end",
                      padding: "10px 0px",
                      borderTop: "3px solid #e4e5e6",
                    }}
                  >
                    <FormGroup>
                      <Button
                        className="mr-3"
                        color="secondary"
                        onClick={() => this.toggleRegisterPlayerModal()}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" color="primary" onClick={() => {}}>
                        Save
                      </Button>
                    </FormGroup>
                  </Col>
                </Form>
              </ModalBody>
              {/* <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={() => this.toggleRegisterPlayerModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        onClick={() => {
                          this.toggleRegisterPlayerModal();
                        }}
                      >
                        Save
                      </Button>
                    </ModalFooter> */}
            </Modal>
          ) : null}
          {this.state.registerParentModal ? (
            <Modal
              isOpen={this.state.registerParentModal}
              toggle={(event) => this.toggleRegisterParentModal()}
              className="modal-md"
            >
              <ModalHeader toggle={() => this.toggleRegisterParentModal()}>
                Register Adult :
              </ModalHeader>
              <ModalBody>
                <Form className="form" onSubmit={this.registerAdult}>
                  {this.state.SPIRegistered ? (
                    <>
                      <Col>
                        <FormGroup>
                          <Label>
                            Select Rush National Program
                            <span
                              style={{
                                color: "red",
                                marginLeft: "5px",
                              }}
                            >
                              *
                            </span>
                          </Label>
                          <Select
                            placeholder="Select the program"
                            value={this.state.selectedSPIParentCamp}
                            options={this.state.SPIParentCampOptions}
                            onChange={(result) => {
                              let SPIParentCampId = result.value;
                              let camp = this.state.SPIParentCamps.find(
                                (SPIParentCamp) =>
                                  SPIParentCamp._id === SPIParentCampId
                              );
                              let SPICamps = camp ? camp.camps : [];
                              let SPICampOptions = SPICamps.map((camp) => ({
                                label: camp.name,
                                value: camp._id,
                              }));
                              let selectedSPICamp = SPICampOptions.length
                                ? SPICampOptions[0]
                                : {};
                              this.setState(
                                {
                                  selectedSPIParentCamp: result,
                                  SPICamps,
                                  SPICampOptions,
                                  selectedSPICamp,
                                },
                                () => this.getRegistrationFormForRushNationals()
                              );
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>
                            Select Rush National Program
                            <span
                              style={{
                                color: "red",
                                marginLeft: "5px",
                              }}
                            >
                              *
                            </span>
                          </Label>
                          <Select
                            placeholder="Select the program"
                            value={this.state.selectedSPICamp}
                            options={this.state.SPICampOptions}
                            onChange={(result) => {
                              this.setState(
                                {
                                  selectedSPICamp: result,
                                },
                                () => this.getRegistrationFormForRushNationals()
                              );
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </>
                  ) : null}
                  {this.state.registerFormFieldsAdult.map(
                    (registerFormField, index) => (
                      <Col key={index}>
                        <FormGroup>
                          {registerFormField.inputType === "text" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <div style={{ display: "flex" }}>
                                <Input
                                  id={index}
                                  name={registerFormField.name}
                                  type="text"
                                  value={
                                    this.state.adult[
                                      registerFormField.keyName
                                    ] || ""
                                  }
                                  onChange={(event) =>
                                    this.updateState(
                                      "adult",
                                      registerFormField.keyName,
                                      event.target.value
                                    )
                                  }
                                  placeholder={registerFormField.placeholder}
                                  required={registerFormField.required}
                                />
                              </div>
                            </>
                          )}
                          {registerFormField.inputType === "number" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <div style={{ display: "flex" }}>
                                <Input
                                  id={index}
                                  name={registerFormField.name}
                                  type="number"
                                  value={
                                    this.state.adult[
                                      registerFormField.keyName
                                    ] || ""
                                  }
                                  onChange={(event) =>
                                    event.target.value > -1 &&
                                    this.updateState(
                                      "adult",
                                      registerFormField.keyName,
                                      event.target.value
                                    )
                                  }
                                  placeholder={registerFormField.placeholder}
                                  required={registerFormField.required}
                                />
                              </div>
                            </>
                          )}
                          {registerFormField.inputType === "datepicker" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                id={index}
                                name={registerFormField.name}
                                type="date"
                                value={
                                  this.state.adult[registerFormField.keyName] ||
                                  ""
                                }
                                onChange={(event) =>
                                  this.updateState(
                                    "adult",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "dropdown" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <Input
                                type="select"
                                name={registerFormField.name}
                                value={
                                  this.state.adult[registerFormField.keyName] ||
                                  "default"
                                }
                                required={registerFormField.required}
                                onChange={(event) =>
                                  this.updateState(
                                    "adult",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                              >
                                <option value="default" disabled>
                                  Select the value
                                </option>
                                {registerFormField.values.map(
                                  (value, index) => (
                                    <option key={index} value={value}>
                                      {value}
                                    </option>
                                  )
                                )}
                              </Input>
                            </>
                          )}
                          {registerFormField.inputType === "fileupload" && (
                            <>
                              <Label>
                                {registerFormField.placeholder}
                                {registerFormField.required && (
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    *
                                  </span>
                                )}
                              </Label>
                              <div>
                                <Label htmlFor={registerFormField._id}>
                                  <span className="btn btn-secondary">
                                    Select File
                                  </span>
                                  <span style={{ marginLeft: "5px" }}>
                                    {
                                      this.state.adult[
                                        `${registerFormField.keyName}FileName`
                                      ]
                                    }
                                  </span>
                                </Label>
                                <input
                                  style={{ display: "none" }}
                                  id={registerFormField._id}
                                  type="file"
                                  onChange={(event) =>
                                    this.handleChange(
                                      "adult",
                                      registerFormField.keyName,
                                      event
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                        </FormGroup>
                      </Col>
                    )
                  )}
                  {this.state.wavierFormFieldsAdult.length ? (
                    <>
                      <Col
                        style={{
                          textAlign: "center",
                          padding: "10px 0px",
                          borderTop: "3px solid #e4e5e6",
                        }}
                      >
                        <h3>Waviers For Adult</h3>
                      </Col>
                      {this.state.wavierFormFieldsAdult.map(
                        (wavierFormField, index) => (
                          <Col key={index}>
                            <FormGroup>
                              {wavierFormField.inputType === "waviers" && (
                                <>
                                  <div className="d-flex">
                                    <CustomInput
                                      type="checkbox"
                                      id={wavierFormField._id}
                                      label={wavierFormField.placeholder}
                                      required={wavierFormField.required}
                                      checked={
                                        this.state.adult[
                                          wavierFormField.keyName
                                        ] || false
                                      }
                                      onChange={(event) =>
                                        this.updateState(
                                          "adult",
                                          wavierFormField.keyName,
                                          event.target.value
                                        )
                                      }
                                    />
                                    {wavierFormField.required && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        *
                                      </span>
                                    )}
                                  </div>
                                  <Input
                                    id={index}
                                    type="textarea"
                                    disabled
                                    style={{ height: "160px" }}
                                    value={wavierFormField.value}
                                  />
                                </>
                              )}
                            </FormGroup>
                          </Col>
                        )
                      )}
                    </>
                  ) : null}
                  <Col
                    style={{
                      textAlign: "end",
                      padding: "10px 0px",
                      borderTop: "3px solid #e4e5e6",
                    }}
                  >
                    <FormGroup>
                      <Button
                        className="mr-3"
                        color="secondary"
                        onClick={() => this.toggleRegisterParentModal()}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" color="primary" onClick={() => {}}>
                        Save
                      </Button>
                    </FormGroup>
                  </Col>
                </Form>
              </ModalBody>
            </Modal>
          ) : null}
          {this.state.adultDeleteConfirmationModal ? (
            <Modal
              isOpen={this.state.adultDeleteConfirmationModal}
              toggle={(event) => this.toggleAdultDeleteConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleAdultDeleteConfirmationModal()}
              >
                Delete Adult
              </ModalHeader>
              <ModalBody>
                Are you sure you want to delete{" "}
                {this.state.rushUser.data.firstName +
                  " " +
                  this.state.rushUser.data.lastName}{" "}
                ?
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleAdultDeleteConfirmationModal()}
                >
                  Cancel
                </Button>
                <Button color="primary" onClick={(event) => this.removeAdult()}>
                  Delete
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.adultEditModal ? (
            <Modal
              isOpen={this.state.adultEditModal}
              toggle={(event) => this.toggleAdultEditModal()}
              className="modal-md"
            >
              <ModalHeader toggle={() => this.toggleAdultEditModal()}>
                Update Adult :
              </ModalHeader>
              <ModalBody>
                <Form className="form" onSubmit={this.updateAdult}>
                  {this.state.registerFormFieldsAdult.map(
                    (registerFormField, index) => (
                      <Col key={index}>
                        <FormGroup>
                          {registerFormField.inputType === "text" && (
                            <>
                              <Label>{registerFormField.placeholder}</Label>
                              {registerFormField.keyName === "email" ? (
                                <div style={{ display: "flex" }}>
                                  <Input
                                    disabled
                                    id={index}
                                    name={registerFormField.name}
                                    type="text"
                                    value={
                                      this.state.adult[
                                        registerFormField.keyName
                                      ] || ""
                                    }
                                    onChange={(event) =>
                                      this.updateState(
                                        "adult",
                                        registerFormField.keyName,
                                        event.target.value
                                      )
                                    }
                                    placeholder={registerFormField.placeholder}
                                    required={registerFormField.required}
                                  />
                                </div>
                              ) : (
                                <div style={{ display: "flex" }}>
                                  <Input
                                    id={index}
                                    name={registerFormField.name}
                                    type="text"
                                    value={
                                      this.state.adult[
                                        registerFormField.keyName
                                      ] || ""
                                    }
                                    onChange={(event) =>
                                      this.updateState(
                                        "adult",
                                        registerFormField.keyName,
                                        event.target.value
                                      )
                                    }
                                    placeholder={registerFormField.placeholder}
                                    required={registerFormField.required}
                                  />
                                </div>
                              )}
                            </>
                          )}
                          {registerFormField.inputType === "number" && (
                            <>
                              <Label>{registerFormField.placeholder}</Label>
                              {registerFormField.keyName === "phone" ? (
                                <div style={{ display: "flex" }}>
                                  <Input
                                    id={index}
                                    name={registerFormField.name}
                                    type="number"
                                    disabled
                                    value={
                                      this.state.adult[
                                        registerFormField.keyName
                                      ] || ""
                                    }
                                    onChange={(event) =>
                                      event.target.value > -1 &&
                                      this.updateState(
                                        "adult",
                                        registerFormField.keyName,
                                        event.target.value
                                      )
                                    }
                                    placeholder={registerFormField.placeholder}
                                    required={registerFormField.required}
                                  />
                                </div>
                              ) : (
                                <div style={{ display: "flex" }}>
                                  <Input
                                    id={index}
                                    name={registerFormField.name}
                                    type="number"
                                    value={
                                      this.state.adult[
                                        registerFormField.keyName
                                      ] || ""
                                    }
                                    onChange={(event) =>
                                      event.target.value > -1 &&
                                      this.updateState(
                                        "adult",
                                        registerFormField.keyName,
                                        event.target.value
                                      )
                                    }
                                    placeholder={registerFormField.placeholder}
                                    required={registerFormField.required}
                                  />
                                </div>
                              )}
                            </>
                          )}
                          {registerFormField.inputType === "datepicker" && (
                            <>
                              <Label>{registerFormField.placeholder}</Label>
                              <Input
                                id={index}
                                name={registerFormField.name}
                                type="date"
                                value={
                                  this.state.adult[registerFormField.keyName] ||
                                  ""
                                }
                                onChange={(event) =>
                                  this.updateState(
                                    "adult",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                                placeholder={registerFormField.placeholder}
                                required={registerFormField.required}
                              />
                            </>
                          )}
                          {registerFormField.inputType === "dropdown" && (
                            <>
                              <Label>{registerFormField.placeholder}</Label>
                              <Input
                                type="select"
                                name={registerFormField.name}
                                value={
                                  this.state.adult[registerFormField.keyName] ||
                                  "default"
                                }
                                required={registerFormField.required}
                                onChange={(event) =>
                                  this.updateState(
                                    "adult",
                                    registerFormField.keyName,
                                    event.target.value
                                  )
                                }
                              >
                                <option value="default" disabled>
                                  Select the value
                                </option>
                                {registerFormField.values.map(
                                  (value, index) => (
                                    <option key={index} value={value}>
                                      {value}
                                    </option>
                                  )
                                )}
                              </Input>
                            </>
                          )}
                          {registerFormField.inputType === "fileupload" && (
                            <>
                              <Label>{registerFormField.placeholder}</Label>
                              <div className="mb-2">
                                {registerFormField.keyName === "photo1"
                                  ? this.state.adult.files &&
                                    this.state.adult.files
                                      .filter((file) => file.name === "photo")
                                      .map((file, index) => (
                                        <img
                                          key={index}
                                          src={file.url}
                                          className="img-responsive"
                                          alt=""
                                          style={{ width: "100%" }}
                                        />
                                      ))
                                  : this.state.adult.files &&
                                    this.state.adult.files
                                      .filter(
                                        (file) =>
                                          file.name ===
                                          registerFormField.keyName
                                      )
                                      .map((file, index) => (
                                        <img
                                          key={index}
                                          src={file.url}
                                          className="img-responsive"
                                          alt=""
                                          style={{ width: "100%" }}
                                        />
                                      ))}
                              </div>
                              <div>
                                <Label htmlFor={registerFormField._id}>
                                  <span className="btn btn-secondary">
                                    Select File
                                  </span>
                                  <span style={{ marginLeft: "5px" }}>
                                    {
                                      this.state.adult[
                                        `${registerFormField.keyName}FileName`
                                      ]
                                    }
                                  </span>
                                </Label>
                                <input
                                  style={{ display: "none" }}
                                  id={registerFormField._id}
                                  type="file"
                                  onChange={(event) =>
                                    this.handleChange(
                                      "adult",
                                      registerFormField.keyName,
                                      event
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                        </FormGroup>
                      </Col>
                    )
                  )}
                  <Col
                    style={{
                      textAlign: "end",
                      padding: "10px 0px",
                      borderTop: "3px solid #e4e5e6",
                    }}
                  >
                    <FormGroup>
                      <Button
                        className="mr-3"
                        color="secondary"
                        onClick={() => this.toggleAdultEditModal()}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" color="primary" onClick={() => {}}>
                        Update
                      </Button>
                    </FormGroup>
                  </Col>
                </Form>
              </ModalBody>
            </Modal>
          ) : null}
          {this.state.adultViewModal ? (
            <Modal
              isOpen={this.state.adultViewModal}
              toggle={(event) => this.toggleAdultViewModal()}
              className="modal-md"
            >
              <ModalHeader toggle={() => this.toggleAdultViewModal()}>
                Adult Details :
              </ModalHeader>
              <ModalBody>
                {this.state.registerFormFieldsAdult.map(
                  (registerFormField, index) => (
                    <Col key={index}>
                      <FormGroup>
                        {index === 0 ? (
                          <>
                            <Label>Credit Cards</Label>
                            <Table striped hover responsive>
                              <thead>
                                <tr>
                                  <th className={"text-center"}>Sr No.</th>
                                  <th className={"text-center"}>Card Number</th>
                                </tr>
                              </thead>
                              <tbody
                                style={{ borderBottom: "1px solid #e9ecef" }}
                              >
                                {this.state.rushUser.stripeCards &&
                                this.state.rushUser.stripeCards.length ? (
                                  this.state.rushUser.stripeCards.map(
                                    (card, index) => (
                                      <tr key={index}>
                                        <td className={"text-center"}>
                                          {index + 1}
                                        </td>
                                        <td className={"text-center"}>
                                          {card.number ? card.number : "-"}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No cards found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </>
                        ) : null}
                        {registerFormField.inputType === "text" ||
                        registerFormField.inputType === "number" ||
                        registerFormField.inputType === "dropdown" ? (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <div style={{ display: "flex" }}>
                              <Input
                                disabled
                                type="text"
                                value={
                                  this.state.adult[registerFormField.keyName] ||
                                  ""
                                }
                              />
                            </div>
                          </>
                        ) : null}
                        {registerFormField.inputType === "datepicker" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              disabled
                              type="text"
                              value={
                                this.state.adult[registerFormField.keyName]
                                  ? moment
                                      .utc(
                                        this.state.adult[
                                          registerFormField.keyName
                                        ]
                                      )
                                      .format("LL")
                                  : ""
                              }
                            />
                          </>
                        )}
                        {registerFormField.inputType === "fileupload" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <div className="mb-2">
                              {registerFormField.keyName === "photo1"
                                ? this.state.adult.files &&
                                  this.state.adult.files
                                    .filter((file) => file.name === "photo")
                                    .map((file, index) => (
                                      <img
                                        key={index}
                                        src={file.url}
                                        className="img-responsive"
                                        alt=""
                                        style={{ width: "100%" }}
                                      />
                                    ))
                                : this.state.adult.files &&
                                  this.state.adult.files
                                    .filter(
                                      (file) =>
                                        file.name === registerFormField.keyName
                                    )
                                    .map((file, index) => (
                                      <img
                                        key={index}
                                        src={file.url}
                                        className="img-responsive"
                                        alt=""
                                        style={{ width: "100%" }}
                                      />
                                    ))}
                            </div>
                          </>
                        )}
                      </FormGroup>
                    </Col>
                  )
                )}
                <Col
                  style={{
                    textAlign: "end",
                    padding: "10px 0px",
                    borderTop: "3px solid #e4e5e6",
                  }}
                >
                  <FormGroup>
                    <Button
                      className="mr-3"
                      color="secondary"
                      onClick={() => this.toggleAdultViewModal()}
                    >
                      Cancel
                    </Button>
                  </FormGroup>
                </Col>
              </ModalBody>
            </Modal>
          ) : null}
          {this.state.cardViewModal ? (
            <Modal
              isOpen={this.state.cardViewModal}
              toggle={(event) => this.toggleCardViewModal()}
              className="modal-md"
            >
              <ModalHeader toggle={(event) => this.toggleCardViewModal()}>
                Credit Card Details
              </ModalHeader>
              <ModalBody>
                <Row
                  style={
                    this.state.addCardCollapse
                      ? {
                          borderBottom: "1px solid #dee2e6",
                          marginBottom: "10px",
                        }
                      : null
                  }
                >
                  <Col>
                    <Button
                      id="toggler"
                      className="float-right mb-2"
                      onClick={() => {
                        this.setState({
                          addCardCollapse: !this.state.addCardCollapse,
                        });
                      }}
                    >
                      Add Credit Card
                    </Button>
                  </Col>
                </Row>
                <UncontrolledCollapse
                  toggler="#toggler"
                  isOpen={this.state.addCardCollapse}
                >
                  <Form className="form" onSubmit={this.addCreditCard}>
                    <Row style={{ padding: "0px 15px" }}>
                      <Col style={{ margin: "auto" }}>
                        <Cards
                          cvc={this.state.cvc}
                          expiry={this.state.expiry}
                          focused={this.state.focus}
                          name={this.state.name}
                          number={this.state.number}
                          callback={(event) => {
                            this.setState({ cardType: event.issuer });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-3">
                        <Label>Adult Name</Label>
                        <Input
                          disabled
                          value={
                            this.state.rushUser.data
                              ? `${this.state.rushUser.data.firstName} ${this.state.rushUser.data.lastName}`
                              : "-"
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-3">
                        <>
                          <Label>Card Number</Label>
                          <FormGroup>
                            <Input
                              id="number"
                              name="number"
                              type="text"
                              maxLength="16"
                              value={this.state.number}
                              onChange={(event) =>
                                this.setState({
                                  number: event.target.value,
                                  focus: "number",
                                })
                              }
                              placeholder="CARD NUMBER"
                              required
                            />
                          </FormGroup>
                        </>
                        <>
                          <Label>Card Name</Label>
                          <FormGroup>
                            <Input
                              id="name"
                              name="name"
                              type="text"
                              value={this.state.name}
                              onChange={(event) =>
                                this.setState({
                                  name: event.target.value,
                                  focus: "name",
                                })
                              }
                              placeholder="CARD NAME"
                              required
                            />
                          </FormGroup>
                        </>
                        <Row>
                          <Col xl={6} lg={6} md={12} sm={12}>
                            <Label>Card Expiration Date</Label>
                            <FormGroup>
                              <Input
                                id="expiry"
                                name="expiry"
                                type="text"
                                maxLength="4"
                                value={this.state.expiry}
                                onChange={(event) =>
                                  this.setState({
                                    expiry: event.target.value,
                                    focus: "expiry",
                                  })
                                }
                                placeholder="MM/YY"
                                required
                              />
                            </FormGroup>
                          </Col>
                          <Col xl={6} lg={6} md={12} sm={12}>
                            <Label>CVC</Label>
                            <FormGroup>
                              <Input
                                id="cvc"
                                name="cvc"
                                type="text"
                                maxLength="4"
                                value={this.state.cvc}
                                onChange={(event) =>
                                  this.setState({
                                    cvc: event.target.value,
                                    focus: "cvc",
                                  })
                                }
                                placeholder="CVC"
                                required
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <>
                          <FormGroup>
                            <Button type="submit" onClick={() => {}}>
                              Add Credit Card
                            </Button>
                          </FormGroup>
                        </>
                      </Col>
                    </Row>
                  </Form>
                </UncontrolledCollapse>
                <Table striped hover responsive>
                  <thead>
                    <tr>
                      <th className={"text-center"}>Sr No</th>
                      <th className={"text-center"}>Adult Name</th>
                      <th className={"text-center"}>Card Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.rushUser.stripeCards &&
                    this.state.rushUser.stripeCards.length ? (
                      this.state.rushUser.stripeCards.map((card, index) => (
                        <tr key={index}>
                          <td className={"text-center"}>{index + 1}</td>
                          <td className={"text-center"}>
                            {this.state.rushUser.data
                              ? `${this.state.rushUser.data.firstName} ${this.state.rushUser.data.lastName}`
                              : "-"}
                          </td>
                          <td className={"text-center"}>
                            {card.number ? card.number : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No cards found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </ModalBody>
            </Modal>
          ) : null}
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
ParentList.contextType = GlobalContext;
export default ParentList;
